import { PlatformDependent } from '@/components/PlatformDependent'
import { TitleSetter } from '@/components/Title'

import { OperatorsViewDDE } from './OperatorsView.dde'
import { OperatorsViewDGE } from './OperatorsView.dge'

const OperatorsView = () => (
  <>
    <TitleSetter title="Operators" />

    <PlatformDependent dde>
      <OperatorsViewDDE />
    </PlatformDependent>

    <PlatformDependent streaming>
      <OperatorsViewDGE />
    </PlatformDependent>
  </>
)

export default OperatorsView
